import {
  setStockVault as setStockVaultPlainAction,
  setStockVaultSize as setStockVaultSizePlainAction
} from '../vault/vaultSlice';
import {validSizes} from "../vault/stockVaultStateFactory";
import {applyStandardVault} from "./applyStandardVaultThunk";
import {setWallWidth} from "../plan/planRootSlice"
const stockVaultWallWidth = 15;

export const setStockVault = () => (dispatch, getState) => {
  const {plan} = getState();
  const {stockVault, floor} = plan;
  const stockFloor = !!floor && floor.isStockFloor ? floor : null;

  if (stockVault) {
    return;
  }
  const currentSize = plan.length + 'x' + plan.width;
  const desiredSize = validSizes.includes(currentSize) ? currentSize : validSizes[2];

  if (currentSize !== desiredSize) {
    const dimensions = desiredSize.split('x');
    const length = parseInt(dimensions[0]);
    const width = parseInt(dimensions[1]);

    dispatch(applyStandardVault({length, width}, plan.lid, stockVault, stockFloor));
  }
  dispatch(setWallWidth({width: stockVaultWallWidth}))
  dispatch(setStockVaultPlainAction(desiredSize));
  dispatch(setStockVaultSizePlainAction(desiredSize));
};
